export default __webpack_public_path__ + "static/media/dtch.c3097450.svg";